const practiceQuestionListData = [
    {
       id: 1,
       question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
    {
        id: 2,
        question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
        activeClass: 'active',
   },
   {
    id: 3,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
   {
    id: 4,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
    {
       id: 5,
       question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
    {
        id: 6,
        question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
   {
    id: 7,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
   {
    id: 8,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
   {
    id: 9,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   },
   {
    id: 10,
    question:"The cork cells seen by Robert Hooke were published in his book 'Micrographia'. It was published in January 1665. It was the first book which illustrate the microscopic view of plants and insects.",
   }
   
]
export default practiceQuestionListData;
